import './_style.scss'
import Listener from '../../core/watcher/Listener'
import BridesCookie from '../../core/cookie/BridesCookie'

Listener.onLoadDOM(() => {
   if (!BridesCookie.getCookieAgree()) {
      setTimeout(() => {
         const agreementsNodeShowClassName = 'cookie-agree--show'
         const selector = '.cookie-agree'
         if (document.querySelector(selector)) {
            const agreementsNode = document.querySelector(selector)
            Listener.onClick(agreementsNode.querySelector('.cookie-agree__btn'), e => {
               e.preventDefault()
               e.stopPropagation()
               BridesCookie.setCookieAgree()
               agreementsNode.classList.remove(agreementsNodeShowClassName)
            })
            agreementsNode.classList.add(agreementsNodeShowClassName)
         } else {
            console.log('selector' + selector + ' is NULL')
         }
      }, 1000)
   }
})